import { motion } from "framer-motion";
import { Scissors, Flame, Sparkles, Ruler, Zap, Baby, Gem, Layers, ArrowRight } from "lucide-react";
import { scrollTo } from "./Navbar";

const ICONS = {
  taglio: Scissors,
  rasatura: Zap,
  taglio_bimbo: Baby,
  barba_trattamento: Flame,
  barba_macchinetta: Ruler,
  combo_tratt_taglio_barba: Sparkles,
  combo_tratt_rasatura_barba: Gem,
  combo_taglio_barba: Layers,
  combo_rasatura_barba: Layers,
};

const CATEGORIES = ["Capelli", "Barba", "Combo con Trattamento", "Combo senza Trattamento"];

export function Services({ services, onSelect }) {
  return (
    <section id="servizi" className="relative py-24 sm:py-36 bg-espresso/40 border-y border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6"
        >
          <div>
            <p className="text-xs font-mono tracking-[0.3em] uppercase text-ember">Servizi & Prezzi</p>
            <h2 className="mt-4 font-serif font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-ivory">
              Il listino della <span className="italic text-ember">bottega.</span>
            </h2>
          </div>
          <p className="max-w-xs text-sm text-stone leading-relaxed">
            Nessuna sovrapposizione, nessuna attesa. La fascia che prenoti è interamente tua.
          </p>
        </motion.div>

        {CATEGORIES.map((cat, ci) => {
          const items = services.filter((s) => s.category === cat);
          if (items.length === 0) return null;
          return (
            <div key={cat} className="mt-14">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="flex items-center gap-4 mb-5"
              >
                <h3 className="font-serif italic text-2xl text-ivory">{cat}</h3>
                <span className="flex-1 h-px bg-white/[0.08]" />
                <span className="text-[10px] font-mono uppercase tracking-widest text-stone">{String(ci + 1).padStart(2, "0")}</span>
              </motion.div>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {items.map((s, i) => {
                  const Icon = ICONS[s.id] || Scissors;
                  return (
                    <motion.div
                      key={s.id}
                      data-testid={`service-card-${s.id.replace(/_/g, "-")}`}
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, margin: "-60px" }}
                      transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
                      className="group relative bg-card border border-white/[0.08] hover:border-ember/40 rounded-lg p-7 flex flex-col transition-all duration-300 hover:-translate-y-1"
                    >
                      {s.badge && (
                        <span className="absolute top-5 right-5 text-[10px] font-mono uppercase tracking-widest text-ember bg-ember/10 border border-ember/25 rounded-full px-3 py-1">
                          {s.badge}
                        </span>
                      )}
                      <div className="w-12 h-12 rounded-sm bg-ember/10 border border-ember/25 flex items-center justify-center text-ember group-hover:bg-ember group-hover:text-white transition-colors duration-300">
                        <Icon size={22} />
                      </div>
                      <h4 className="mt-6 font-serif text-2xl text-ivory leading-snug pr-16">{s.name}</h4>
                      <p className="mt-3 text-sm text-sand leading-relaxed flex-1">{s.desc}</p>
                      <div className="mt-6 pt-5 border-t border-white/[0.08] flex items-center justify-between">
                        <div>
                          <span className="font-serif text-3xl text-ivory">{s.price}</span>
                          <span className="ml-3 text-xs font-mono uppercase tracking-widest text-stone">{s.duration} min</span>
                        </div>
                        <button
                          data-testid={`service-book-${s.id.replace(/_/g, "-")}`}
                          onClick={() => {
                            onSelect(s.id);
                            scrollTo("prenota");
                          }}
                          className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-ember hover:text-ember-hover transition-colors duration-300"
                        >
                          Prenota <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-300" />
                        </button>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
